import FormField from '@cloudscape-design/components/form-field';
import CSDTimeInput, {
  TimeInputProps,
} from '@cloudscape-design/components/time-input';
import { get } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

type InputProps = {
  name: string;
  label?: string;
  description?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  stretch?: boolean;
  className?: string;
  format?: TimeInputProps.Format;
};

const TimeInput = ({
  name,
  label,
  description,
  defaultValue = '',
  placeholder = '',
  disabled = false,
  stretch = false,
  className = '',
  format = 'hh:mm',
}: InputProps) => {
  const { control, formState } = useFormContext();

  return (
    <FormField
      stretch={stretch}
      description={description}
      label={label}
      className={className}
      errorText={get(formState.errors, name)?.message as string | undefined}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <CSDTimeInput
            {...field}
            onChange={({ detail }) => field.onChange(detail.value)}
            placeholder={placeholder}
            format={format}
            disabled={disabled}
          />
        )}
      />
    </FormField>
  );
};

export default TimeInput;
